/**
 * Normalizes a URL so the app only advertises https (display + QR).
 */
export function ensureHttpsUrl(url: string): string {
  const t = (url || "").trim();
  if (!t) {
    return t;
  }
  const lower = t.toLowerCase();
  if (lower.startsWith("https://")) {
    return t;
  }
  if (lower.startsWith("http://")) {
    return "https://" + t.slice(7);
  }
  if (t.startsWith("//")) {
    return "https:" + t;
  }
  return "https://" + t.replace(/^\/+/, "");
}
